// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".HiddenField .hiddenFieldLabel {\n  word-wrap: anywhere;\n  color: #1a1d24;\n  font-size: 16px;\n  line-height: 24px;\n  margin-right: 10px;\n}\n.HiddenField .hiddenFieldToggle {\n  color: #62677e;\n  line-height: 24px;\n}", ""]);
// Exports
module.exports = exports;
